import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: '',
            lang: navigator.language || navigator.userLanguage
    };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        //console.log("wfwefwefF",this.state.lang )

        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>




                ​

                ​










            </div>
            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            <div>


                <div style={{width: "90%", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >


                    {lang==="en" && <div style={{width: "50%",margin: "auto", maxWidth:"50%", minWidth:"20em",verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >
                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>Contact Us</span><p/>
                        <span style={{fontSize: ".8em", fontWeight:"bold"}}>The Morrow Firm </span><p/>
                        <span style={{fontSize: ".8em"}}><a href="https://www.google.com/maps/place/100+Bayview+Cir,+Newport+Beach,+CA+92660/@33.6560594,-117.8700064,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcde4fc06acd99:0x71da2605fdf0695!8m2!3d33.656055!4d-117.8678177">100 Bayview Cir, Ste 100  </a></span><p/>
                        <span style={{fontSize: ".8em"}}><a href="https://www.google.com/maps/place/100+Bayview+Cir,+Newport+Beach,+CA+92660/@33.6560594,-117.8700064,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcde4fc06acd99:0x71da2605fdf0695!8m2!3d33.656055!4d-117.8678177">Newport Beach, CA 92660</a></span><p/>
                        <span style={{fontSize: ".8em"}}><a href="tel:(213)%20282-8166">(213) 282-8166 </a></span><p/>
                        <span style={{fontSize: ".8em"}}><a href="mailto:info@morrowfirm.com">info@morrowfirm.com</a></span>
                    </div>}

                    {lang==="zh" && <div style={{width: "50%",margin: "auto", maxWidth:"50%", minWidth:"20em",verticalAlign:"top",  display: "inline-block", backgroundColor:"white", padding: "30px",}} >
                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>联系我们</span><p/>
                        <span style={{fontSize: ".8em", fontWeight:"bold"}}>The Morrow Firm </span><p/>
                        <span style={{fontSize: ".8em"}}><a href="https://www.google.com/maps/place/100+Bayview+Cir,+Newport+Beach,+CA+92660/@33.6560594,-117.8700064,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcde4fc06acd99:0x71da2605fdf0695!8m2!3d33.656055!4d-117.8678177">100 Bayview Cir, Ste 100  </a></span><p/>
                        <span style={{fontSize: ".8em"}}><a href="https://www.google.com/maps/place/100+Bayview+Cir,+Newport+Beach,+CA+92660/@33.6560594,-117.8700064,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcde4fc06acd99:0x71da2605fdf0695!8m2!3d33.656055!4d-117.8678177">Newport Beach, CA 92660 </a></span><p/>
                        <span style={{fontSize: ".8em"}}><a href="tel:(213)%20282-8166">(213) 282-8166 </a></span><p/>
                        <span style={{fontSize: ".8em"}}><a href="mailto:info@morrowfirm.com">info@morrowfirm.com</a></span>
                    </div>}



                </div>


            </div>
            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, { getUser})(contact);



// WEBPACK FOOTER //
// ./src/Containers/contact.js